<script setup lang="ts">
const store = usePortfolioStore()
</script>

<template>
  <section id="services" class="px-1 py-8 md:py-12">
    <h2 data-reveal class="text-2xl font-extrabold md:text-3xl"><span class="text-accent">خدمات</span> من</h2>
    <div class="mt-8 grid gap-4 md:grid-cols-2">
      <NeonTempPartialsServiceCard v-for="s in store.services" :key="s.title" data-reveal>
        <span class="grid h-10 w-10 place-content-center rounded-xl bg-accent/15 text-accent">
          <svg viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
            <path d="M12 3l2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5z" />
          </svg>
        </span>
        <h3 class="mt-4 font-bold">{{ s.title }}</h3>
        <p class="mt-2 text-sm leading-7 text-muted">{{ s.description }}</p>
      </NeonTempPartialsServiceCard>
    </div>
  </section>
</template>
